import { UPDATE_SMARTCHAT_STATE } from 'constants/actionTypes/smartChat';
import { UPDATE_GLADCHAT_STATE } from 'constants/actionTypes/gladChat';

export default {
    updateSmartChatState: function (isSmartChatAvailable, isSmartChatVisible, chatData, isChatOpen) {
        return {
            type: UPDATE_SMARTCHAT_STATE,
            payload: {
                isSmartChatAvailable,
                isSmartChatVisible,
                chatData,
                isChatOpen
            }
        };
    },
    updateGladChatState: function ({ isChatOpen, entryFlag = false, clickPage = '' }) {
        return {
            type: UPDATE_GLADCHAT_STATE,
            payload: {
                isChatOpen,
                entryFlag,
                clickPage
            }
        };
    }
};
